import css from 'styled-jsx/css';

export default css`
  .AmpListicle :global(.AmpImg) {
    margin-bottom: 1.5rem;
  }

  .AmpListicle :global(.ImageCaption) {
    padding: 0 0 1rem 0;
  }
`;
